import { render, staticRenderFns } from "./BirdCount.vue?vue&type=template&id=0278fcb4&scoped=true&"
import script from "./BirdCount.vue?vue&type=script&lang=js&"
export * from "./BirdCount.vue?vue&type=script&lang=js&"
import style0 from "./BirdCount.vue?vue&type=style&index=0&id=0278fcb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0278fcb4",
  null
  
)

export default component.exports